import React, { useState, useEffect } from "react";
import { ReactNode } from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import { AlertOctagon, AlertTriangle, Loader } from "lucide-react";

const CurrentGasFees = (): JSX.Element => {
  const [level, setLevel] = useState("");

  const maxGasFee = 110;
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        "https://gas-api.metaswap.codefi.network/networks/1/suggestedGasFees"
      );
      const { low, estimatedBaseFee } = await res.json();
      const currentFee =
        Number(low.suggestedMaxPriorityFeePerGas) + Number(estimatedBaseFee);
      console.log("current_fee", currentFee);
      if (currentFee >= maxGasFee) {
        setLevel("high");
      } else if (currentFee <= maxGasFee - 30) {
        setLevel("low");
      } else {
        setLevel("medium");
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box>
      {(() => {
        switch (level) {
          case "high":
            return (
              <DisplayFees
                title="Ethereum gas fees are currently very high."
                desc="If you are transferring from Palm to Ethereum Mainnet, you may incur significant delays in transferring your asset. Waiting for lower gas fees may mitigate delays."
              >
                <AlertTriangle color="palmNetwork.900" size={20} />
              </DisplayFees>
            );
          case "medium":
            return (
              <DisplayFees
                title="Ethereum gas fees are currently higher than usual."
                desc="If you are transferring from Palm to Ethereum Mainnet, you may incur some delay in transferring your asset. Waiting for lower gas fees may mitigate delays."
              >
                <AlertOctagon color="palmNetwork.800" size={20} />
              </DisplayFees>
            );
          case "low":
            return <></>;
          default:
            return <LoadingFees />;
        }
      })()}
    </Box>
  );
};

export default CurrentGasFees;

interface IDisplayFees {
  title?: string;
  desc?: string;
  children: ReactNode | ReactNode[];
}

const DisplayFees: React.FC<IDisplayFees> = ({
  title,
  desc,
  children,
}: IDisplayFees) => {
  return (
    <Box
      border="1px solid #3589D5"
      mt="36px"
      py="13px"
      px="16px"
      display="flex"
      justifyContent="flex-start"
    >
      <Box mr="8px">{children}</Box>
      <Box>
        <Heading as="h5" fontSize="16px" mb="20px">
          {title}
        </Heading>
        <Text lineHeight="22px">{desc}</Text>
      </Box>
    </Box>
  );
};

const LoadingFees = () => {
  return (
    <Box
      border="1px solid #3589D5"
      mt="36px"
      py="13px"
      px="16px"
      display="flex"
      justifyContent="flex-start"
    >
      <Box mr="8px">
        <Loader size={14} className="rotating" />
      </Box>
      <Box>
        <Heading as="h5" fontSize="16px">
          Loading gas fees.
        </Heading>
      </Box>
    </Box>
  );
};
